export enum TimeFramesTypes {
  LastWeek = 1,
  LastMonth = 2,
  LastQuarter = 3,
  LastYear = 4,
  SpecificDate = 5
}
